import React from "react";
import {
  BadgeDollarSign, Clock, ShieldCheck, Smile, MapPin, Building2,
} from "lucide-react";
import { WHY_US } from "../../lib/site-data";

const ICONS = { BadgeDollarSign, Clock, ShieldCheck, Smile, MapPin, Building2 };

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export const WhyChooseUs = () => {
  return (
    <section
      id="why-us"
      data-testid="why-choose-us-section"
      className="relative bg-[#1D2B53] py-20 lg:py-28 overflow-hidden"
    >
      <div className="absolute inset-0 opacity-[0.04]" style={{
        backgroundImage: "radial-gradient(circle at 1px 1px, white 1px, transparent 0)",
        backgroundSize: "32px 32px"
      }}></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#FBBF24] mb-4">
            Why Choose Us
          </div>
          <h2
            data-testid="why-us-heading"
            className="font-display text-3xl sm:text-4xl lg:text-5xl font-black text-white tracking-tight leading-tight"
          >
            Six reasons your neighbors keep calling us back.
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {WHY_US.map((item, idx) => {
            const Icon = ICONS[item.icon] || ShieldCheck;
            return (
              <div
                key={item.title}
                data-testid={`why-us-item-${slug(item.title)}`}
                className="group p-7 rounded-2xl border border-white/10 bg-white/[0.03] hover:bg-white/[0.06] hover:border-[#2563EB]/40 transition-all duration-300"
              >
                <div className="flex items-center justify-between">
                  <div className="h-12 w-12 rounded-xl bg-[#2563EB] flex items-center justify-center">
                    <Icon className="h-6 w-6 text-white" strokeWidth={1.75} />
                  </div>
                  <span className="font-display text-3xl font-black text-white/10 group-hover:text-[#FBBF24]/40 transition-colors">
                    0{idx + 1}
                  </span>
                </div>
                <h3 className="mt-6 font-display text-xl font-bold text-white">
                  {item.title}
                </h3>
                <p className="mt-2 text-[15px] leading-relaxed text-white/70">
                  {item.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
